<div class="tabs-container" *ngIf="loggedInUserRole != 'HR Admin'">
  <ion-row *ngIf="!router.url.includes('Setup')  ">
    <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
      <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
        <mat-tab-group #tabGroup class="pt-10 pr-10" (selectedTabChange)="tabTypeChanged($event)">

          <mat-tab label="MyAssetReport"
            *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  person
                </span>My Asset Report</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="MyDeptReport"
            *ngIf=" (authorityNameCheck ) && !(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' )">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  ads_click
                </span>My Dept Report </span>
            </ng-template>
          </mat-tab>

        </mat-tab-group>
      </div>
    </ion-col>
  </ion-row>
  <div class="card">
  </div>
</div>
<div class="container">
  <!-- <ion-row class="mb-10">
    <ion-col size="12" size-md="4" size-lg="3" class="mt-10">
      <div class="formLabelRegularfs16 mb-5">
        Year<span class="red-cl">&nbsp;*</span>
      </div>
      <mat-form-field class="w-100 mat-height40 mat-input-style">
        <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
          (selectionChange)="changeYear(selectedYearForCompetency)">
          <mat-option [value]="item.year" *ngFor="let item of pmsYears">
            {{sharedService.transformYearToFyFormat(item.year)}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ion-col>


    <ion-col size="12" size-md="4" size-lg="3"
      *ngIf="loggedInUserRole == 'Super Admin' || loggedInUserRole == 'HR Admin' ||(authorityNameCheck &&selectedTypeTabName == 'MyDeptReport' )"
      class="mt-10">
      <div class="formLabelRegularfs16  mb-5">
        Select Dept
      </div>
      <ng-multiselect-dropdown [placeholder]="'Select Dept'" [settings]="dropdownSettings" [data]="getDeptList"
        [(ngModel)]="selectedDep" (onSelect)="onSelectDepartment()" (onDeSelect)="onDeSelectDepartment()"
        (onSelectAll)="selectAllDepartment($event)" (onDeSelectAll)="onDeSelectAllDepartment()">
      </ng-multiselect-dropdown>
    </ion-col>

    <ion-col size="12" size-md="4" size-lg="3"
      *ngIf="loggedInUserRole == 'Super Admin' || loggedInUserRole == 'HR Admin'||(authorityNameCheck &&selectedTypeTabName == 'MyDeptReport' )"
      class="mt-10">
      <div class="formLabelRegularfs16  mb-5">
        Select Employee
      </div>
      <ng-multiselect-dropdown [placeholder]="'Select Employee'" [settings]="dropdownSettings" [data]="getEmployeeList"
        [(ngModel)]="selectedEmployee" (onSelect)="onSelectEmployee()" (onDeSelect)="onDeSelectEmployee()"
        (onSelectAll)="SelectALLEmployee($event)" (onDeSelectAll)="onDeSelectALLEmployee()">
      </ng-multiselect-dropdown>
    </ion-col>


  </ion-row> -->

  <ion-row class="align-center">

  <!-- Left dropdown -->
  <ion-col size="12" size-md="4" size-lg="4" class="mt-10">
    <mat-form-field class="w-100 mat-height40 mat-input-style">
      <mat-select placeholder="Select"
                  [(ngModel)]="selectedYearForCompetency"
                  (selectionChange)="changeYear(selectedYearForCompetency)">
        <mat-option *ngFor="let item of pmsYears" [value]="item.year">
          {{ sharedService.transformYearToFyFormat(item.year) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ion-col>

  <!-- Right buttons (FLEX RIGHT) -->
  <ion-col size="12" size-md="8" size-lg="8" class="mt-10" style="display:flex; justify-content:flex-end; gap:16px;">

    <span class="fs-20 material-icons btn-reset"
          style="cursor:pointer;"
          [class.clicked]="isClicked"
          (click)="resetGrid()"
          (animationend)="isClicked = false">
      refresh
    </span>

    <span class="fs-20 material-icons icon-download"
          style="cursor:pointer;"
          (click)="onBtExport('Asset Report')">
      download
    </span>

  </ion-col>

</ion-row>




  <!------------------------------------------------------- HR Login ------------------------------------------------>

  <div class="card  employeeTab">

    <div *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'">

      <!-- <div style="margin: 20px !important;"> -->
        

      <mat-sidenav-container style="height: 100%;">
        <!-- Main Content with AG Grid -->
        <mat-sidenav-content>
          <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-quartz"
            [rowData]="assetAllocationFromAuthority" [columnDefs]="nestedHeadersColumn" [gridOptions]="gridOptions"
            [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
            [pagination]="pagination" [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="paginationPageSizeSelector" [detailRowAutoHeight]="detailRowAutoHeight"
            [localeText]="{ noRowsToShow: 'No Data Found' }">
          </ag-grid-angular>
        </mat-sidenav-content>


        <!-- Right Side Sidenav -->
        <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
          <!-- HEADER -->
          <div class="details-header">
            <h2>Asset Details</h2>
            <button mat-icon-button (click)="closeDetails()">
              <mat-icon class="close-icon">close</mat-icon>
            </button>
          </div>

          <!-- CONTENT -->
          <div class="details-content" *ngIf="selectedRow">
            <mat-card class="detail-card" *ngFor="let col of nestedHeadersColumn">
              <mat-card-content>
                <div class="detail-row">
                  <mat-icon class="detail-icon">trending_flat</mat-icon>
                  <div class="detail-text">

                    <!-- LABEL -->
                    <span class="detail-label">{{ col.headerName }} </span>

                    <!-- STATUS BADGE -->
                    <ng-container *ngIf="col.headerName === 'Employee Status'; else approvalCheck">
                      <span class="status-badge" [ngClass]="{
                                'RECEIVED_ASSET': selectedRow[col.field]?.toUpperCase().includes('RECEIVED_ASSET'),
                                'REPAIR_ASSET': selectedRow[col.field]?.toUpperCase().includes('REPAIR_ASSET'),
                                'RETURNING_ASSET_DUE_TO_EXIT': selectedRow[col.field]?.toUpperCase().includes('RETURNING_ASSET_DUE_TO_EXIT'),
                                'RECEIVED_AFTER_REPAIR': selectedRow[col.field]?.toUpperCase().includes('RECEIVED_AFTER_REPAIR'),
                              }">
                        {{ formatStatus(selectedRow[col.field]) }}
                      </span>
                    </ng-container>

                    <!-- APPROVAL BADGE -->
                    <ng-template #approvalCheck>
                      <ng-container *ngIf="col.headerName === 'Authority Department Comment'; else normalContent">
                        <span class="status-badge" [ngClass]="{
                                  'ASSET_GIVEN': selectedRow[col.field] === 'ASSET_GIVEN',
                                  'RECEIVED_AFTER_EXIT': selectedRow[col.field] === 'RECEIVED_AFTER_EXIT',
                                  'NOT_RECEIVED_AFTER_EXIT': selectedRow[col.field] === 'NOT_RECEIVED_AFTER_EXIT',
                                  'IN_PROGRESS': selectedRow[col.field] === 'IN_PROGRESS',
                                  'OTHER_REASON': selectedRow[col.field] === 'OTHER_REASON'
                                }">
                          {{ formatStatus(selectedRow[col.field]) }}
                        </span>
                      </ng-container>
                    </ng-template>

                    <!-- NORMAL DATA / DOCUMENT -->
                    <ng-template #normalContent>
                      <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                        <ng-container *ngIf="selectedRow[col.field]; else noFile">
                          <img src="assets/icon/yellowdownload.png" alt="download" width="18" height="18"
                            style="cursor:pointer" (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))" />
                        </ng-container>
                        <ng-template #noFile>
                          <span></span>
                        </ng-template>
                      </ng-container>

                      <ng-template #textValue>
                        <span>
                          {{
                          (col.field === 'date'
                          || col.field === 'employeeCommentDate'
                          || col.field === 'dateOfAllocation'
                          || col.field === 'authorityCommentDate')
                          ? formatDate(selectedRow[col.field])
                          : (selectedRow[col.field] || selectedRow[col.field])
                          }}
                        </span>

                      </ng-template>

                    </ng-template>

                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-sidenav>
      </mat-sidenav-container>

      <!-- <div class="table-container">

          <table class="custom-table rounded-header">

            <thead>
              <tr>
             
                <th *ngFor="let item of nestedHeaders" class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="p-5 verticle-center justify-content-space-between icon-style">
                    {{ item?.label }}
                    
                    <div class="d-flex flex-column ml-10">
                      <i (click)="onSortAssending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                    <i (click)="onSortDesending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              
              <tr *ngFor="let row of assetAllocationFromAuthority; let rowId = index">

                <td>{{ row.assetName || '-' }}</td>
                <td>{{ row.employeeName || '-' }}</td>
                <td>{{ row.band || '-' }}</td>
                <td>{{ row.authorityDepartment || '-' }}</td>
                <td>{{ row.authorityName || '-' }}</td>
                <td>{{ row.dateOfAllocation | date: 'dd-MM-yyyy' || '-' }}</td>
                <td>
                  <textarea rows="3" cols="32" name="currentAssetDescription"
                  class="edittextarea"  [(ngModel)]=" row.currentAssetDescription"
                  maxlength="255" [ngModelOptions]="{standalone: true}"  readonly></textarea>
                </td>
                <td>{{ formatedataVariable(row.employeeAssetStatus)}}</td>
                <td>
                  <textarea rows="3" cols="32" name="employeeComment"
                  class="edittextarea"  [(ngModel)]="row.employeeComment"
                  maxlength="255" [ngModelOptions]="{standalone: true}"  readonly></textarea>
                </td>
                <td>{{ row.employeeCommentDate | date: 'dd-MM-yyyy' || '-' }}</td>
                <td>
                  {{formatedataVariable( row.authorityDepartmentComment)}}
 
                </td>
                <td>{{ row.authorityCommentDate |  date: 'dd-MM-yyyy' || '-' }}</td>
                <td>{{ row.assetRepairTime || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div> -->
      <!--   (onAssetNameClickInside)="employeeAsset($event)" -->
      <!-- </div> -->
    </div>
  </div>
  <!-- ---------------------------------------------------------Employee-------------------------------------------------------------------- -->

  <div class="card  employeeTab"
    *ngIf="selectedTypeTabName =='MyAssetReport' && loggedInUserRole != 'HR Admin'  && loggedInUserRole != 'Super Admin'">

    <!-- <div class="card-body"> -->
    <!-- <div> -->

    <!-- <div class="p-10"> -->
        <mat-sidenav-container style="height: 100%;">
        <!-- Main Content with AG Grid -->
        <mat-sidenav-content>
          <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-quartz"
            [rowData]="assetAllocationFromAuthority" [columnDefs]="nestedHeadersColumn" [gridOptions]="gridOptions"
            [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
            [pagination]="pagination" [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="paginationPageSizeSelector" [detailRowAutoHeight]="detailRowAutoHeight"
            [localeText]="{ noRowsToShow: 'No Data Found' }">
          </ag-grid-angular>
        </mat-sidenav-content>


        <!-- Right Side Sidenav -->
        <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
          <!-- HEADER -->
          <div class="details-header">
            <h2>Asset Details</h2>
            <button mat-icon-button (click)="closeDetails()">
              <mat-icon class="close-icon">close</mat-icon>
            </button>
          </div>

          <!-- CONTENT -->
          <div class="details-content" *ngIf="selectedRow">
            <mat-card class="detail-card" *ngFor="let col of nestedHeadersColumn">
              <mat-card-content>
                <div class="detail-row">
                  <mat-icon class="detail-icon">trending_flat</mat-icon>
                  <div class="detail-text">

                    <!-- LABEL -->
                    <span class="detail-label">{{ col.headerName }} </span>

                    <!-- STATUS BADGE -->
                    <ng-container *ngIf="col.headerName === 'Employee Status'; else approvalCheck">
                      <span class="status-badge" [ngClass]="{
                                'RECEIVED_ASSET': selectedRow[col.field]?.toUpperCase().includes('RECEIVED_ASSET'),
                                'REPAIR_ASSET': selectedRow[col.field]?.toUpperCase().includes('REPAIR_ASSET'),
                                'RETURNING_ASSET_DUE_TO_EXIT': selectedRow[col.field]?.toUpperCase().includes('RETURNING_ASSET_DUE_TO_EXIT'),
                                'RECEIVED_AFTER_REPAIR': selectedRow[col.field]?.toUpperCase().includes('RECEIVED_AFTER_REPAIR'),
                              }">
                        {{ formatStatus(selectedRow[col.field]) }}
                      </span>
                    </ng-container>

                    <!-- APPROVAL BADGE -->
                    <ng-template #approvalCheck>
                      <ng-container *ngIf="col.headerName === 'Authority Department Comment'; else normalContent">
                        <span class="status-badge" [ngClass]="{
                                  'ASSET_GIVEN': selectedRow[col.field] === 'ASSET_GIVEN',
                                  'RECEIVED_AFTER_EXIT': selectedRow[col.field] === 'RECEIVED_AFTER_EXIT',
                                  'NOT_RECEIVED_AFTER_EXIT': selectedRow[col.field] === 'NOT_RECEIVED_AFTER_EXIT',
                                  'IN_PROGRESS': selectedRow[col.field] === 'IN_PROGRESS',
                                  'OTHER_REASON': selectedRow[col.field] === 'OTHER_REASON'
                                }">
                          {{ formatStatus(selectedRow[col.field]) }}
                        </span>
                      </ng-container>
                    </ng-template>

                    <!-- NORMAL DATA / DOCUMENT -->
                    <ng-template #normalContent>
                      <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                        <ng-container *ngIf="selectedRow[col.field]; else noFile">
                          <img src="assets/icon/yellowdownload.png" alt="download" width="18" height="18"
                            style="cursor:pointer" (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))" />
                        </ng-container>
                        <ng-template #noFile>
                          <span></span>
                        </ng-template>
                      </ng-container>

                      <ng-template #textValue>
                        <span>
                          {{
                          (col.field === 'date'
                          || col.field === 'employeeCommentDate'
                          || col.field === 'dateOfAllocation'
                          || col.field === 'authorityCommentDate')
                          ? formatDate(selectedRow[col.field])
                          : (selectedRow[col.field] || selectedRow[col.field])
                          }}
                        </span>

                      </ng-template>

                    </ng-template>

                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-sidenav>
      </mat-sidenav-container>

    <!-- <div class="table-container">

      <table class="custom-table rounded-header">

        <thead>
          <tr>

            <th *ngFor="let item of nestedHeaders" class="fs-14 fs_12ForMobile font_bold cl-black">
              <div class="p-5 verticle-center justify-content-space-between icon-style">
                {{ item?.label }}
                
                <div class="d-flex flex-column ml-10">
                  <i (click)="onSortAssending(item.sortingName)"
                    class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                  <i (click)="onSortDesending(item.sortingName)"
                    class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of assetAllocationFromAuthority; let rowId = index">

            <td>{{ row.assetName || '-' }}</td>
            <td>{{ row.employeeName || '-' }}</td>
            <td>{{ row.band || '-' }}</td>
            <td>{{ row.authorityDepartment || '-' }}</td>
            <td>{{ row.authorityName || '-' }}</td>
            <td>{{ row.dateOfAllocation | date: 'dd-MM-yyyy' || '-' }}</td>
            <td>
              <textarea rows="3" cols="32" name="currentAssetDescription" class="edittextarea"
                [(ngModel)]=" row.currentAssetDescription" maxlength="255" [ngModelOptions]="{standalone: true}"
                readonly></textarea>
            </td>
            <td>{{ formatedataVariable(row.employeeAssetStatus) }}</td>
            <td>
              <textarea rows="3" cols="32" name="employeeComment" class="edittextarea" [(ngModel)]="row.employeeComment"
                maxlength="255" [ngModelOptions]="{standalone: true}" readonly></textarea>
            </td>
            <td>{{ row.employeeCommentDate | date: 'dd-MM-yyyy' || '-' }}</td>
            <td>
              {{formatedataVariable(row.authorityDepartmentComment)}}
        
            </td>
            <td>{{ row.authorityCommentDate | date: 'dd-MM-yyyy' || '-' }}</td>
            <td>{{ row.assetRepairTime || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div> -->
    <div class="mt-10" style="font-weight: bold;">
      <!-- {{tableDataDetails.length}} entries -->
    </div>
    <!-- </div> -->
    <!-- </div> -->
    <!-- </div> -->
  </div>

  <!-------------------------------------------------------Manager Login ------------------------------------------------>

  <div class="card  employeeTab">

    <div *ngIf="selectedTypeTabName=='MyDeptReport'">
        <mat-sidenav-container style="height: 100%;">
        <!-- Main Content with AG Grid -->
        <mat-sidenav-content>
          <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-quartz"
            [rowData]="assetAllocationFromAuthority" [columnDefs]="nestedHeadersColumn" [gridOptions]="gridOptions"
            [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
            [pagination]="pagination" [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="paginationPageSizeSelector" [detailRowAutoHeight]="detailRowAutoHeight"
            [localeText]="{ noRowsToShow: 'No Data Found' }">
          </ag-grid-angular>
        </mat-sidenav-content>


        <!-- Right Side Sidenav -->
        <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
          <!-- HEADER -->
          <div class="details-header">
            <h2>Asset Details</h2>
            <button mat-icon-button (click)="closeDetails()">
              <mat-icon class="close-icon">close</mat-icon>
            </button>
          </div>

          <!-- CONTENT -->
          <div class="details-content" *ngIf="selectedRow">
            <mat-card class="detail-card" *ngFor="let col of nestedHeadersColumn">
              <mat-card-content>
                <div class="detail-row">
                  <mat-icon class="detail-icon">trending_flat</mat-icon>
                  <div class="detail-text">

                    <!-- LABEL -->
                    <span class="detail-label">{{ col.headerName }} </span>

                    <!-- STATUS BADGE -->
                    <ng-container *ngIf="col.headerName === 'Employee Status'; else approvalCheck">
                      <span class="status-badge" [ngClass]="{
                                'RECEIVED_ASSET': selectedRow[col.field]?.toUpperCase().includes('RECEIVED_ASSET'),
                                'REPAIR_ASSET': selectedRow[col.field]?.toUpperCase().includes('REPAIR_ASSET'),
                                'RETURNING_ASSET_DUE_TO_EXIT': selectedRow[col.field]?.toUpperCase().includes('RETURNING_ASSET_DUE_TO_EXIT'),
                                'RECEIVED_AFTER_REPAIR': selectedRow[col.field]?.toUpperCase().includes('RECEIVED_AFTER_REPAIR'),
                              }">
                        {{ formatStatus(selectedRow[col.field]) }}
                      </span>
                    </ng-container>

                    <!-- APPROVAL BADGE -->
                    <ng-template #approvalCheck>
                      <ng-container *ngIf="col.headerName === 'Authority Department Comment'; else normalContent">
                        <span class="status-badge" [ngClass]="{
                                  'ASSET_GIVEN': selectedRow[col.field] === 'ASSET_GIVEN',
                                  'RECEIVED_AFTER_EXIT': selectedRow[col.field] === 'RECEIVED_AFTER_EXIT',
                                  'NOT_RECEIVED_AFTER_EXIT': selectedRow[col.field] === 'NOT_RECEIVED_AFTER_EXIT',
                                  'IN_PROGRESS': selectedRow[col.field] === 'IN_PROGRESS',
                                  'OTHER_REASON': selectedRow[col.field] === 'OTHER_REASON'
                                }">
                          {{ formatStatus(selectedRow[col.field]) }}
                        </span>
                      </ng-container>
                    </ng-template>

                    <!-- NORMAL DATA / DOCUMENT -->
                    <ng-template #normalContent>
                      <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                        <ng-container *ngIf="selectedRow[col.field]; else noFile">
                          <img src="assets/icon/yellowdownload.png" alt="download" width="18" height="18"
                            style="cursor:pointer" (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))" />
                        </ng-container>
                        <ng-template #noFile>
                          <span></span>
                        </ng-template>
                      </ng-container>

                      <ng-template #textValue>
                        <span>
                          {{
                          (col.field === 'date'
                          || col.field === 'employeeCommentDate'
                          || col.field === 'dateOfAllocation'
                          || col.field === 'authorityCommentDate')
                          ? formatDate(selectedRow[col.field])
                          : (selectedRow[col.field] || selectedRow[col.field])
                          }}
                        </span>

                      </ng-template>

                    </ng-template>

                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-sidenav>
      </mat-sidenav-container>

      <!-- <div class="table-container">

        <table class="custom-table rounded-header">

          <thead>
            <tr>

              <th *ngFor="let item of nestedHeaders" class="fs-14 fs_12ForMobile font_bold cl-black">
                <div class="p-5 verticle-center justify-content-space-between icon-style">
                  {{ item?.label }}
                  
                  <div class="d-flex flex-column ml-10">
                    <i (click)="onSortAssending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                    <i (click)="onSortDesending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of assetAllocationFromAuthority; let rowId = index">

              <td>{{ row.assetName || '-' }}</td>
              <td>{{ row.employeeName || '-' }}</td>
              <td>{{ row.band || '-' }}</td>
              <td>{{ row.authorityDepartment || '-' }}</td>
              <td>{{ row.authorityName || '-' }}</td>
              <td>{{ row.dateOfAllocation | date: 'dd-MM-yyyy' || '-' }}</td>
              <td>
                <textarea rows="3" cols="32" name="currentAssetDescription" class="edittextarea"
                  [(ngModel)]=" row.currentAssetDescription" maxlength="255" [ngModelOptions]="{standalone: true}"
                  readonly></textarea>
              </td>
              <td>{{ formatedataVariable(row.employeeAssetStatus)}}</td>
              <td>
                <textarea rows="3" cols="32" name="employeeComment" class="edittextarea"
                  [(ngModel)]="row.employeeComment" maxlength="255" [ngModelOptions]="{standalone: true}"
                  readonly></textarea>
              </td>
              <td>{{ row.employeeCommentDate | date: 'dd-MM-yyyy' || '-' }}</td>
              <td>
                {{formatedataVariable(row.authorityDepartmentComment)}}
                
              </td>
              <td>{{ row.authorityCommentDate | date: 'dd-MM-yyyy' || '-' }}</td>
              <td>{{ row.assetRepairTime || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div> -->
      <div class="mt-10" style="font-weight: bold;">
       
      </div>
    </div>
  </div>
</div>